export default "__VITE_ASSET__Caw8CneS__"